import * as React from "react";
import type { SVGProps } from "react";

const SvgShareIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={28}
        height={26}
        viewBox="0 0 28 26"
        {...props}
    >
        <g
            id="Group_10382"
            data-name="Group 10382"
            transform="translate(-99 0)"
        >
            <ellipse
                id="Ellipse_423"
                data-name="Ellipse 423"
                cx="3.5"
                cy="4"
                rx="3.5"
                ry="4"
                transform="translate(103 10.727)"
                fill="currentColor"
            />
            <ellipse
                id="Ellipse_424"
                data-name="Ellipse 424"
                cx="4"
                cy="3.5"
                rx="4"
                ry="3.5"
                transform="translate(116 2.727)"
                fill="currentColor"
            />
            <path
                id="Path_1541"
                data-name="Path 1541"
                d="M-13509.877,10074.354l1.379-4,2.789-1.338,2.295,1.09,2.051-1.09,2.553,1.608,1.348,3.977Z"
                transform="translate(13610.021 -10049.396)"
                fill="currentColor"
            />
            <path
                id="Path_1542"
                data-name="Path 1542"
                d="M-13509.877,10074.354l1.379-4,2.789-1.338,2.295,1.09,2.051-1.09,2.553,1.608,1.348,3.977Z"
                transform="translate(13623.496 -10057.106)"
                fill="currentColor"
            />
            <g
                id="Group_6967"
                data-name="Group 6967"
                transform="translate(99 0)"
            >
                <path
                    id="Union_56"
                    data-name="Union 56"
                    d="M0,25.726l.269-.9c.83-2.769,1.62-4.964,4.538-5.8l.43-.123,2.171.638,2.172-.638.429.123c2.92.832,3.71,3.027,4.54,5.8l.269.9Zm2.048-1.411H12.77c-.811-1.752-.861-3.133-2.776-3.8L7.409,21.544,4.824,20.515C2.909,21.181,2.861,22.563,2.048,24.315Zm.873-9.875a4.365,4.365,0,0,1,4.487-4.233A4.365,4.365,0,0,1,11.9,14.44a4.365,4.365,0,0,1-4.487,4.232A4.365,4.365,0,0,1,2.921,14.44Zm1.5,0a2.911,2.911,0,0,0,2.992,2.821A2.909,2.909,0,0,0,10.4,14.44a2.909,2.909,0,0,0-2.992-2.822A2.911,2.911,0,0,0,4.417,14.44Zm8.975,3.526.269-.9c.831-2.768,1.621-4.963,4.539-5.8l.43-.123,2.171.638,2.171-.638.43.123c2.919.832,3.71,3.027,4.541,5.8l.269.9Zm2.049-1.41h10.72c-.811-1.752-.86-3.133-2.774-3.8L20.8,13.785l-2.585-1.028C16.3,13.423,16.252,14.8,15.441,16.556Zm.874-9.875A4.364,4.364,0,0,1,20.8,2.45a4.364,4.364,0,0,1,4.487,4.231A4.365,4.365,0,0,1,20.8,10.913,4.365,4.365,0,0,1,16.314,6.681Zm1.495,0a3,3,0,0,0,5.983,0,3,3,0,0,0-5.983,0ZM.734,9.809a8.048,8.048,0,0,1,.307-2.3C2.323,2.993,6.3,1.175,11.089,2.381a9.493,9.493,0,0,1,1.685.6L12.067.92a.7.7,0,0,1,.481-.886.764.764,0,0,1,.946.452l1.534,4.467L10.292,6.405a.754.754,0,0,1-.94-.455.7.7,0,0,1,.479-.89l2.3-.7-1.048-.506q-.193-.058-.387-.108c-3.989-1.008-7.147.365-8.216,4.127a6.681,6.681,0,0,0-.256,1.92.729.729,0,0,1-.738.714H1.479A.727.727,0,0,1,.734,9.809Z"
                    fill="#737373"
                />
            </g>
        </g>
    </svg>
);
export default SvgShareIcon;
